import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/gps_bg.png';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-image: url(${bg});
	background-size: contain;
	background-position: center top;
	background-repeat: no-repeat;
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	background-color: #0c0c0c;
	padding: 20px;
	border-radius: 40px 40px 0 0;
	transition: height 0.3s ease-in-out;
`;

const StyledSearchContainer = styled.div`
	display: flex;
`;

const StyledSearchBackButton = styled.div<{ $active: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${({ $active }) => ($active ? '50px' : '0px')};
	height: 50px;
	margin-right: ${({ $active }) => ($active ? '10px' : '0px')};
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	opacity: ${({ $active }) => ($active ? '1' : '0')};
	transition:
		background-color 0.3s ease,
		width 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-right 0.3s ease-in-out2;
	cursor: pointer;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(1);
		}
	}
`;

const StyledCategoriesContainer = styled.div<{ $activePoint?: boolean }>`
	display: grid;
	grid-template-columns: repeat(4, 70px);
	grid-auto-rows: 96px;
	column-gap: 20px;
	row-gap: 10px;
	${({ $activePoint }) =>
		$activePoint &&
		css`
			padding-bottom: 30px;
		`}
`;

const StyledActiveContainer = styled.div`
	position: absolute;
	bottom: 30px;
	width: 100%;
	height: 140px;
	padding: 0 20px;
	background: linear-gradient(180deg, rgba(12, 12, 12, 0) 0%, #0c0c0c 70%);
`;

const StyledCategoryIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 70px;
	height: 70px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

const StyledCategoryContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	cursor: pointer;

	${Text} {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.5);
		transition: color 0.3s ease;
		white-space: nowrap;
	}

	&:hover {
		${Text} {
			color: #ffffff;
		}

		${StyledCategoryIcon} {
			background-color: #ffffff;

			img {
				filter: invert(1);
			}
		}
	}
`;

const StyledListContainer = styled.div<{ $search?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledListItem = styled.div<{ $active?: boolean }>`
	display: grid;
	grid-template-columns: 20px 1fr auto 30px;
	gap: 10px;
	align-items: center;
	padding: 0 10px 0 15px;
	height: 50px;
	min-height: 50px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;

	& > img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;

		&:nth-child(2) {
			font-weight: 500;
		}

		&:nth-child(3) {
			/* margin-right: ${({ $active }) => ($active ? '10px' : '0px')}; */
			font-weight: 500;

			span {
				opacity: 0.5;
				font-weight: 400;
			}
		}
	}
`;

const StyledActiveListItem = styled(StyledListItem)`
	background-color: #2d70d9;
	padding: 0 10px 0 15px;
	margin-top: 70px;
`;

const StyledHead = styled.div`
	position: relative;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
		white-space: nowrap;
	}
`;

export {
	StyledActiveContainer,
	StyledActiveListItem,
	StyledCategoriesContainer,
	StyledCategoryContainer,
	StyledCategoryIcon,
	StyledContainer,
	StyledHead,
	StyledListContainer,
	StyledListItem,
	StyledSearchBackButton,
	StyledSearchContainer,
	StyledWrapper,
};
